import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { LOGGED_OUT_PATH } from '@/auth/login-gate';
import { Layout } from '@/components/layout/layout';
import { Dashboard } from '@/pages/dashboard';
import { Deployments } from '@/pages/deployments';
import { Models } from '@/pages/models';
import { SwapProfiles } from '@/pages/swap-profiles';
import { CustomRecognizers } from '@/pages/custom-recognizers';
import { Conversations } from '@/pages/conversations';
import { ConversationDetailPage } from '@/pages/conversation-detail';
import { AuditLog } from '@/pages/audit-log';
import { SettingsPage } from '@/pages/settings';
import { LoggedOut } from '@/pages/logged-out';

// The admin shell (sidebar + topbar) wraps every operator page. The logged-out screen is
// deliberately kept out of it — see @/pages/logged-out (EW-190).
function AdminShell(): JSX.Element {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

export function App(): JSX.Element {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={LOGGED_OUT_PATH} element={<LoggedOut />} />
        <Route element={<AdminShell />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/deployments" element={<Deployments />} />
          <Route path="/models" element={<Models />} />
          <Route path="/swap-profiles" element={<SwapProfiles />} />
          <Route path="/custom-recognizers" element={<CustomRecognizers />} />
          <Route path="/conversations" element={<Conversations />} />
          <Route path="/conversations/:id" element={<ConversationDetailPage />} />
          <Route path="/audit-log" element={<AuditLog />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/auth/callback" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
